import { BaseControlOption } from '../control-options/control-option.interface';
import { TextControl } from '../controls/text-control.model';

export class UrlControl extends TextControl {

  constructor(id: string, label: string, value: string, ...options: BaseControlOption[]) {
    super(id, label, value, options);
    this.className = "UrlControl";
  }

}
